export const TEXT_SEARCH_FIELD_ID = '*';
